import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import {showLoader} from "../../../components/loader/loader";

// actions
import {ADD_STATE, REMOVE_STATE, setApp, setUdn, setUserIsAdmin} from "../../../redux/actions/generics/IndexedActions";
import RoutList from "./_list";

const Rout = props => {
    const path = props.path || 'classificators/rout';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn !== null)
            props.setUdn(path, _udn);
    },[]);

    return <>
        { loading && showLoader() }
        { componentState && <RoutList path={path} /> }
    </>
}

const mapStateToProps = state => ({ })
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(Rout)
